import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_ALL_CPTS_QUERY_KEY } from "../types/CommonTypes";
import { getAuthValue } from "../../authModule/hooks/useAuthValue";
import {
  CPTType,
  normalizeCodesForUi,
} from "../../codingModule/type/normalizeCodesForUi";

async function getAllCpts(
  hospitalId: string,
  id?: string,
  type?: string,
): Promise<CPTType[]> {
  const { tenantId, realm } = getAuthValue();
  const url =
    type === "HCPCS"
      ? `analytics/hcpcs-codes/${id}`
      : `analytics/cpt-codes/${id}`;

  const { data } = await fetcher({
    url,
    headers: {
      "x-realm": realm,
      "x-hospital-id": hospitalId,
      "x-tenant-id": tenantId,
    },
  });

  return normalizeCodesForUi(data, type);
}

export default function useGetAllCptsQuery(
  hospitalId: string,
  id?: string,
  type?: string,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: [GET_ALL_CPTS_QUERY_KEY, hospitalId, id, type],
    queryFn: () => getAllCpts(hospitalId, id, type),
    refetchInterval: 60000,
    enabled: !!id && !!hospitalId && enabled,
  });
}
